import * as translationService from '../services/translationService'
import { getCurrentStepType, VISIT_REQUEST_STEPS } from '../services/stepService'
import { prop, path, flatten } from 'ramda'

const application = prop('application')
const broker = prop('broker')
const property = prop('property')
const propertyInfoId = prop('propertyInfoId')
const contacts = path(['application', 'contacts'])
const residents = path(['application', 'residents'])
const totalAdults = path(['application', 'residents', 0]) // Dirty, 0 = always adults
const totalChildren = path(['application', 'residents', 1]) // Dirty, 1 = always children
const totalPets = state => {
  let totalPetsCount = 0
  if (!residents(state)) return 0
  residents(state).forEach((petCategory, index) => {
    if (index < 2) return // Dirty, 0 & 1 are adults and children
    totalPetsCount += +petCategory.value
  })

  return totalPetsCount
}
const contactsList = state =>
  contacts(state)
    .map(contact => `${contact.firstname} ${contact.lastname}`)
    .join(', ')

const incomesList = state =>
  contacts(state)
    .map(person => {
      return `${person.firstname} ${person.lastname} (${person.income ? person.income.length : ''})`
    })
    .join(', ')

const incomes = state => flatten(contacts(state).map(contact => (contact.income ? contact.income : [])))
const incomesCount = state => incomes(state).length
const documents = state =>
  flatten(
    incomes(state)
      .filter(income => income.documents)
      .map(income => income.documents),
  )
const documentsCount = state => documents(state).length
const dateOfOccupancy = state => application(state).dateOfOccupancy
const isRentIntentionValid = path(['application', 'isRentIntentionValid'])
const residentsSummary = state => {
  const stepType = getCurrentStepType(state.step)
  return translationService.residentsSummary(
    totalAdults(state) ? totalAdults(state).value : 0,
    totalChildren(state) ? totalChildren(state).value : 0,
    stepType === 'VISIT_REQUEST_STEPS' ? undefined : totalPets(state),
  )
}
const contractSummary = state => translationService.contractSummary(contactsList(state))
const rentIntentionSummary = state => translationService.rentIntentionSummary(dateOfOccupancy(state))
const incomeSummary = state => translationService.incomeSummary(incomesList(state))
const documentsSummary = state => translationService.documentsSummary(documentsCount(state))

export const getIsFirstPhase = state => {
  const { step } = state
  const stepType = getCurrentStepType(step)
  return stepType === VISIT_REQUEST_STEPS
}

export const getIsIncomeRequired = state => {
  const { property = {} } = state
  const { broker } = property
  const isFirstPhase = getIsFirstPhase(state)

  // Income is always required when its not the first phase
  if (!isFirstPhase) {
    return true
  }

  // If the broker has the `INTAKE_INCOME_OPTIONAL` flag, else it's optional
  return broker && broker.features ? !broker.features.includes('INTAKE_INCOME_OPTIONAL') : true
}

export const getShouldIncludeIncomeStatement = state => {
  const { property = {} } = state
  const { broker } = property
  const isFirstPhase = getIsFirstPhase(state)

  // Income is always required when its not the first phase
  if (!isFirstPhase) {
    return true
  }

  // If the broker has the `INCOME_REQUIRED` flag, else it's optional
  return broker && broker.features ? broker.features.includes('INTAKE_INCLUDE_INCOME_STATEMENT') : false
}

export default {
  application,
  broker,
  property,
  propertyInfoId,
  totalAdults,
  totalChildren,
  totalPets,
  dateOfOccupancy,
  isRentIntentionValid,
  incomes,
  incomesCount,
  documents,
  documentsCount,
  residentsSummary,
  rentIntentionSummary,
  incomeSummary,
  documentsSummary,
  contractSummary,
  getIsFirstPhase,
  getIsIncomeRequired,
  getShouldIncludeIncomeStatement,
}



// WEBPACK FOOTER //
// ./src/selectors/flowSelector.js